import * as types from '../../actions/actionTypes';
import initialState from '../initialState';
import _ from 'lodash';


export default function departmentsReducer(state = initialState.departments, action) {
    let newState = {...state};
    let newData = [];

    switch (action.type) {
        case types.LOAD_DEPARTMENTS_SUCCESS:
            return action.departments;
        case types.DELETE_DEPARTMENT_SUCCESS:
            const data = state.data.filter(department => department.id !== action.id);
            return {...state, ...{data}, ...{total: state.total - 1}};
        case types.UPDATE_DEPARTMENT_SUCCESS:

            const index = _.findIndex(state.data, { id: action.department.id });

            if (index === undefined) {
                return state;
            }
            newData = [...newState.data];
            newData.splice(index, 1, action.department);
            newState.data = newData;
            return newState;
        case types.CREATE_DEPARTMENT_SUCESSS:
            return [...state, ...action.department];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web/src/reducers/portal/departmentsReducer.js